import { Injectable } from '@angular/core';
import { ToastController, LoadingController, Platform } from 'ionic-angular';

import { Storage } from '@ionic/storage';
import { Camera, CameraOptions } from '@ionic-native/camera';

@Injectable()
export class Tools {
  tab:any='viewpdv';
  version:any;
  path:any=null;
  conectado:boolean=true;

  constructor(
    private toastCtrl: ToastController,
    private nativeStorage: Storage,
    public loadingCtrl: LoadingController,
    public platform: Platform,
    private camera: Camera
  ){
    // this.isOnline();
  }

  tratCallback(res:any){
    if(res){
      return {status:true,data:res}
    }else{
      return {status:false,msg:'Não encontrado'}
    }
  }

  showAlert(tipo:any,msg:any,time?:any){
    if(tipo=='toast'){
      let toast = this.toastCtrl.create({
        message: msg,
        duration: time||3000,
        position: 'top'
      });
      toast.present();
    }
    if(tipo=='alert'){
      alert(msg);
    }
  }

  showLoading(msg:any){
    return this.loadingCtrl.create({content:msg})
  }

  storage(tipo:any,key:any,value:any,callback:any){
    if(tipo=='save'||tipo=='set'){
      this.nativeStorage.set(key,value);
      callback({status:true})
    }
    else if(tipo=='load'||tipo=='get'){
      this.nativeStorage.get(key).then((res)=>callback(this.tratCallback(res)));
    }
    else if(tipo=='del'||tipo=='remove'){
      this.nativeStorage.remove(key);
      callback({status:true})
    }
  }

  openCamera(callback:any){
    const options = {
      quality:100,
      destinationType: this.camera.DestinationType.DATA_URL,
      sourceType:1,
      targetWidth: 640,
      targetHeight: 960,
      correctOrientation: true
    }

    this.camera.getPicture(options)
    .then((imageData) => {
     let base64Image = 'data:image/jpeg;base64,' + imageData;
     callback(base64Image);
    }, (err) => {
      callback(null);
    });
  }

  isOnline(){
    console.log('Chamou Event Online');
    window.addEventListener("offline", () => {
      this.conectado = false;
      console.log("Me Derrubaram Aqui");
    });
    window.addEventListener("online", () => {
      this.conectado = true;
      console.log("PAI TA ON");
    });
  }

  getStatusOnline() {
    return this.conectado;
  }
}



// WEBPACK FOOTER //
// ./src/providers/tools/tools.ts